module.exports = __webpack_public_path__ + "img/vehicle-violation.2b17fde1.svg";